<template>
  <div class="home">
    <ParticlesBG />
    <section id="page-content">
      <About class="reveal-section reveal-delay-1" />
      <Projects class="reveal-section reveal-delay-2" />
      <Services class="reveal-section reveal-delay-3" />
    </section>
    <BodyFooter />
  </div>
</template>

<script>
import ParticlesBG from '@/components/ParticlesBG.vue'
import About from '@/components/About.vue';
import BodyFooter from '@/components/BodyFooter.vue';
import Projects from '@/components/Projects.vue';
import Services from '@/components/Services.vue'

export default {
  name: 'HomeView',
  components: {    
    About,
    ParticlesBG,
    Projects,
    Services,
    BodyFooter
  }
}
</script>

<style scoped>
#page-content {
  position: relative;
  margin: -7rem auto 0;
  max-width: 1180px;
  width: min(94vw, 1180px);
  display: grid;
  gap: 2.2rem;
  text-align: left;
  z-index: 1;
  margin-bottom: 2.2rem;
}
</style>
